var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    staticClass: "px-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Period",
      "label-for": "dateRange",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "range": "",
      "placeholder": "Select date range"
    },
    model: {
      value: _vm.localFilters.dateRange,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilters, "dateRange", $$v);
      },
      expression: "localFilters.dateRange"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fleet Category",
      "label-for": "categoryId",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('v-multiselect', {
    attrs: {
      "tag-placeholder": "Fleets",
      "placeholder": "Search Fleets",
      "label": "name",
      "track-by": "code",
      "options": _vm.fleetCategoryOpt,
      "multiple": true,
      "taggable": true
    },
    model: {
      value: _vm.localFilters.vehicleTypeIds,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilters, "vehicleTypeIds", $$v);
      },
      expression: "localFilters.vehicleTypeIds"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fleet Name",
      "label-for": "vehicleIds",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('v-multiselect', {
    attrs: {
      "tag-placeholder": "Fleets",
      "placeholder": "Search Fleets",
      "label": "name",
      "track-by": "code",
      "options": _vm.fleetNameOpt,
      "multiple": true,
      "taggable": true
    },
    model: {
      value: _vm.localFilters.vehicleIds,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilters, "vehicleIds", $$v);
      },
      expression: "localFilters.vehicleIds"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "status",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.statusList
    },
    model: {
      value: _vm.localFilters.status,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilters, "status", $$v);
      },
      expression: "localFilters.status"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Filter Options",
      "label-for": "ownership",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-radio', {
    staticClass: "mr-3",
    attrs: {
      "name": "radio-a",
      "value": "jobClass"
    },
    model: {
      value: _vm.localFilters.filterJobType,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilters, "filterJobType", $$v);
      },
      expression: "localFilters.filterJobType"
    }
  }, [_vm._v(" Job Class ")]), _c('b-form-radio', {
    attrs: {
      "name": "radio-b",
      "value": "jobType"
    },
    model: {
      value: _vm.localFilters.filterJobType,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilters, "filterJobType", $$v);
      },
      expression: "localFilters.filterJobType"
    }
  }, [_vm._v(" Job Type ")])], 1)])], 1), _vm.localFilters.filterJobType === 'jobClass' ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Class",
      "label-for": "job-class",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('v-multiselect', {
    attrs: {
      "placeholder": "Search job class",
      "label": "name",
      "id": "job-class",
      "track-by": "code",
      "options": _vm.jobClassList,
      "multiple": true,
      "taggable": true
    },
    model: {
      value: _vm.localFilters.jobClassIds,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilters, "jobClassIds", $$v);
      },
      expression: "localFilters.jobClassIds"
    }
  })], 1)], 1) : _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Type",
      "label-for": "job-type",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('v-multiselect', {
    attrs: {
      "placeholder": "Search job type",
      "label": "name",
      "id": "job-type",
      "track-by": "code",
      "options": _vm.jobTypeList,
      "multiple": true,
      "taggable": true
    },
    model: {
      value: _vm.localFilters.jobTypeIds,
      callback: function callback($$v) {
        _vm.$set(_vm.localFilters, "jobTypeIds", $$v);
      },
      expression: "localFilters.jobTypeIds"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }